/** Remove legacy Disengaged RSS.com embeds from story HTML. */
export function stripPodcastPlayers(html: string) {
  return html
    .replace(/<iframe\b[^>]*player\.rss\.com[^>]*>[\s\S]*?<\/iframe>\s*/gi, "")
    .replace(/<iframe\b[^>]*src=["'][^"']*player\.rss\.com[^"']*["'][^>]*\/?>\s*/gi, "")
    .trim()
}
